module.exports = __webpack_public_path__ + "static/media/logo-light-theme.43ef7001.svg";